import { Link, Typography } from "@mui/material";
import { EIRCODE_FINDER_URL } from "@constants";
import { useTranslation } from "react-i18next";

export const EircodeHelperText = () => {
    const { t } = useTranslation(["common", "address"]);

    return (
        <Typography color="secondary" variant="small">
            {`${t("address:dontKnowYourEircode")}? `}
            <Link href={EIRCODE_FINDER_URL} rel="noreferrer" target="_blank" underline="always">
                <b>{t("common:lookItUp")}</b>
            </Link>
        </Typography>
    );
};
